import script from "./Text.vue?vue&type=script&setup=true&lang=ts"
export * from "./Text.vue?vue&type=script&setup=true&lang=ts"

import "./Text.vue?vue&type=style&index=0&id=4510b415&scoped=true&lang=less"

import exportComponent from "/Users/nikkizeng/Desktop/running/ph-miao-wechat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4510b415"]])

export default __exports__